export default __webpack_public_path__ + "static/media/pagcor.a190a732.webp";